import React from "react";
import { BookOpen, Cpu, Headphones, ClipboardList, FileText, CalendarCheck, Brain, LineChart } from "lucide-react";

const ITEMS = [
  { icon: BookOpen, title: "10 Years Question Bank", desc: "20,000+ MCQs from the last 10 years with topic-wise division across 19 subjects." },
  { icon: Cpu, title: "AI-Powered Explanations", desc: "Get detailed, concept-oriented explanations for every question." },
  { icon: Headphones, title: "AI Tutor", desc: "24×7 AI tutor that answers your doubts and explains concepts on demand." },
  { icon: ClipboardList, title: "Mock Tests & Analytics", desc: "800+ full-length and daily exams with advanced analytics to track your progress." },
  { icon: FileText, title: "High-Yield Notes", desc: "Quick revision notes for all 19 NEET PG & INI-CET subjects." },
  { icon: CalendarCheck, title: "Personalized Study Plan", desc: "AI-generated study plan with daily goals & smart reminders." },
];

export default function Features() {
  return (
    <section id="features" className="py-20 md:py-28 relative overflow-hidden">
      <div className="absolute inset-0 bg-white" />
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-2xl mx-auto mb-12">
          <div className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-[0.2em] text-blue-700 bg-blue-50 px-3 py-1.5 rounded-full">
            <span className="h-1.5 w-1.5 rounded-full bg-blue-600" /> Everything You Need to Succeed
          </div>
          <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight text-slate-900 mt-4">
            Built for serious NEET PG aspirants
          </h2>
          <p className="text-base text-slate-600 mt-3 leading-relaxed">
            A complete toolkit — content, intelligence and analytics — to push you from preparation to results.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4 lg:gap-6">
          {ITEMS.map((it, i) => {
            const Icon = it.icon;
            return (
              <div
                key={it.title}
                data-testid={`feature-card-${i}`}
                className="group relative bg-white border border-slate-200 rounded-2xl p-6 lift overflow-hidden"
              >
                <div className="absolute -right-12 -top-12 h-32 w-32 rounded-full bg-blue-50 opacity-0 group-hover:opacity-100 transition-opacity" />
                <div className="relative">
                  <div className="h-12 w-12 rounded-2xl bg-gradient-to-br from-blue-50 to-indigo-50 ring-1 ring-blue-600/10 flex items-center justify-center">
                    <Icon className="h-6 w-6 text-blue-600" strokeWidth={2.2} />
                  </div>
                  <h3 className="mt-4 font-heading text-lg font-bold text-slate-900">{it.title}</h3>
                  <p className="text-sm text-slate-600 mt-2 leading-relaxed">{it.desc}</p>
                </div>
              </div>
            );
          })}
        </div>

        {/* Bottom strip */}
        <div className="mt-12 grid sm:grid-cols-3 gap-4">
          {[
            { icon: Brain, k: "98%", v: "AI explanation accuracy" },
            { icon: LineChart, k: "50,000+", v: "Aspirants preparing daily" },
            { icon: ClipboardList, k: "800+", v: "Daily & full-length exams" },
          ].map((s) => {
            const I = s.icon;
            return (
              <div key={s.v} className="flex items-center gap-4 p-5 rounded-2xl bg-blue-50/60 border border-blue-100">
                <I className="h-7 w-7 text-blue-700" />
                <div>
                  <div className="font-heading text-2xl font-extrabold text-slate-900">{s.k}</div>
                  <div className="text-sm text-slate-600">{s.v}</div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
